module.exports = __webpack_public_path__ + "img/2.9fcda4a3.png";